import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MessageCircle, X } from "lucide-react";
import { usePlatformAuth } from "@/contexts/PlatformAuthContext";
import { platformClient } from "@/lib/musicApi";

// Round 3 Item 14 — win-back chat teaser. A SINGLE moment: fires once on return
// (a session flag set at subscription success), and only when the now-Don user
// genuinely has unread messages from SAMTWO. It consumes the flag immediately so
// it never persists and never duplicates the standing unread badge.
const FLAG = "samtwo_show_dm_winback";

export const DmWinbackTeaser = () => {
  const { isSubscriber, isDon, loading } = usePlatformAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (loading) return; // wait until auth is settled before consuming the flag
    let flag;
    try { flag = sessionStorage.getItem(FLAG); } catch { flag = null; }
    if (flag !== "1") return;
    // Not a Don (e.g. a new Boss): consume the one-time flag, show nothing.
    if (!(isSubscriber && isDon)) { try { sessionStorage.removeItem(FLAG); } catch { /* noop */ } return; }
    try { sessionStorage.removeItem(FLAG); } catch { /* noop */ }
    platformClient.get("/dms/me/unread-count")
      .then(({ data }) => { if ((data.count || 0) > 0) setShow(true); })
      .catch(() => {});
  }, [loading, isSubscriber, isDon]);

  if (!show) return null;

  return (
    <div
      data-testid="dm-winback-teaser"
      className="fixed left-1/2 -translate-x-1/2 z-[10005] w-[92%] max-w-md rounded-2xl px-4 py-3 flex items-center gap-3 shadow-lg"
      style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 84px)", background: "var(--bg-surface)", border: "1px solid var(--accent-primary)" }}
    >
      <div className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: "var(--accent-primary)", color: "#fff" }}>
        <MessageCircle size={18} />
      </div>
      <p className="text-sm flex-1" style={{ color: "var(--text-primary)" }}>{t("messages.winbackLine")}</p>
      <button
        onClick={() => { setShow(false); navigate("/messages"); }}
        data-testid="dm-winback-cta"
        className="text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap"
        style={{ background: "var(--accent-primary)", color: "#fff" }}
      >
        {t("messages.winbackCta")}
      </button>
      <button onClick={() => setShow(false)} data-testid="dm-winback-dismiss" className="p-1" style={{ color: "var(--text-secondary)" }} aria-label="Dismiss">
        <X size={16} />
      </button>
    </div>
  );
};

export default DmWinbackTeaser;
